import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  removeWaitingOrder,
  removeWaitingOrderAll,
  removeWaitingOrderByOrderAwaitId,
} from '../../actions/posAction';
import {
  deleteOrderAwaitAsync,
  deleteOrderAwaitAtCloudFlareWorker,
  getOrderAwaitByBranchIdxFrIdxAtCloudFlareWorker
} from '../../api/api';
import { httpPost, httpUrl } from '../../api/httpClient';
import '../../css/modal.scss';
import { comma } from '../../lib/util/numberUtil';
import { modalStyle } from '../../lib/util/codeUtil';
import { withRouter } from 'react-router-dom';
import image from '../../res/image';

class WaitingOrderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  removeAll = () => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content:
        '대기 주문 목록을 전부 삭제하시겠습니까? 한번 삭제하는 경우 다시 불러올 수 없습니다.',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        self.props.posReducer.waitingOrders.forEach(async (row) => {
          // 다른 곳에서 대기주문을 delete할 때는 서비스의 연속성을 위해 delete응답을 기다리지 않도록 앞에 await를 붙이지 않았다.
          // 하지만 여기서 대기주문을 delete할 때 await를 써주지 않으면, [a,b,c]라는 대기주문목록이 있을 때 b주문을 삭제하기도 전에
          // 이미 반복문에서 removeWaitingOrderByOrderAwaitId를 모두 완료하여 c주문은 리덕스에서는 사라지지만 실제 주문은 남아있는 경우가 발생
          await deleteOrderAwaitAsync(row);// TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
          /*await deleteOrderAwaitAtCloudFlareWorker(row);*/
          self.props.removeWaitingOrderByOrderAwaitId(row.id);
        });
      },
      onCancel() {},
    });
  };
  remove = (id) => {
    const self = this;
    Modal.confirm({
      ...modalStyle,
      content: '대기 주문을 삭제하시겠습니까?',
      okText: '확인',
      cancelText: '취소',
      onOk() {
        deleteOrderAwaitAsync({ id }).finally( () => {
          self.props.removeWaitingOrderByOrderAwaitId(id);
        }); // TODO ojoomi: redis에 있는 대기주문이 모두 없어지면 이 라인 코드 삭제
        /*deleteOrderAwaitAtCloudFlareWorker({ id }).finally( () => {
          self.props.removeWaitingOrderByOrderAwaitId(id);
        });*/
      },
      onCancel() {},
    });
  };

  render() {
    const { close } = this.props;
    return (
      <React.Fragment>
        <div className="Modal-overlay" onClick={close} />
        <div className="Modal-wide">
          <div className="pw-title">주문 대기 목록</div>
          <div className="pw-image" onClick={close}>
            <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
          </div>
          <div className="waitingorder-content">
            <div className="waitingorder-element-all">
              <div className="waitingorder-element-block">
                <div className="waitingorder-element-block-menu">
                  <div className="waitingorder-element-block-menu-text1">
                    주문시간
                  </div>
                  <div className="waitingorder-element-block-menu-text2">
                    고객정보
                  </div>
                  <div className="waitingorder-element-block-menu-text1">
                    상품가액
                  </div>
                  <div className="waitingorder-element-block-menu-text3 mobileoff">
                    선택
                  </div>
                  <div className="waitingorder-element-block-menu-text3 mobileoff">
                    삭제
                  </div>
                </div>
              </div>
              {/* 기본 */}
              <div className="waitingorder-element-block-field-wrapper mobileoff">
                {(!this.props.posReducer.waitingOrders ||
                  this.props.posReducer.waitingOrders.length) === 0 && (
                  <div style={{ textAlign: 'center', padding: '50px' }}>
                    내역이 없습니다.
                  </div>
                )}
                {this.props.posReducer.waitingOrders.map((row, index) => {
                  return (
                    <div
                      key={index}
                      className="waitingorder-element-block-field">
                      <div className="waitingorder-element-block-field-text1">
                        {row.orderDate}
                      </div>
                      <div className="waitingorder-element-block-field-text2">
                        {row.destAddr1}
                        {row.destAddr2}
                        <div className="waitingorder-element-block-field-text2-sub">
                          {row.custPhone}
                        </div>
                      </div>
                      <div className="waitingorder-element-block-field-text1">
                        {comma(row.orderPrice)}원
                      </div>
                      <div className="waitingorder-element-block-field-text3">
                        <div
                          className="waitingorder-element-block-field-btn1"
                          onClick={() => {
                            // this.props.onSelect(row);
                            this.props.close();
                            this.props.history.push({
                              pathname: '/main',
                              state: row,
                            });
                          }}>
                          선택
                        </div>
                      </div>
                      <div className="waitingorder-element-block-field-text3">
                        <div
                          className="waitingorder-element-block-field-btn2"
                          onClick={() => this.remove(row.id)}>
                          삭제
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* 모바일버전 */}
              <div className="waitingorder-element-block-field-wrapper mobile">
                {(!this.props.posReducer.waitingOrders ||
                  this.props.posReducer.waitingOrders.length) === 0 && (
                  <div style={{ textAlign: 'center', padding: '50px' }}>
                    내역이 없습니다.
                  </div>
                )}
                {this.props.posReducer.waitingOrders.map((row, index) => {
                  return (
                    <div
                      key={index}
                      className="waitingorder-element-block-field">
                      <div
                        onClick={() => {
                          this.props.onSelect(row);
                          this.props.close();
                        }}>
                        <div className="waitingorder-element-block-field-text1">
                          {row.orderDate}
                        </div>
                        <div className="waitingorder-element-block-field-text2">
                          {row.destAddr1}
                          {row.destAddr2}
                          <div className="waitingorder-element-block-field-text2-sub">
                            {row.custPhone}
                          </div>
                        </div>
                        <div className="waitingorder-element-block-field-text3">
                          {comma(row.orderPrice)}원
                        </div>
                      </div>
                      {/* <div className="waitingorder-element-block-field-btn1" onClick={()=>{
                                                    this.props.onSelect(row);
                                                    this.props.close();
                                                }}>선택</div> */}
                      <div
                        className="waitingorder-element-block-field-btn2"
                        onClick={() => this.remove(row.idx)}>
                        삭제
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* 모바일버전 끝 */}
            </div>
            <div className="waitingorder-btn-wrapper">
              <div className="waitingorder-btn-delete" onClick={this.removeAll}>
                전체삭제
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginReducer, posReducer } = state;
  return { loginReducer, posReducer };
};
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      removeWaitingOrder,
      removeWaitingOrderAll,
      removeWaitingOrderByOrderAwaitId,
    },
    dispatch
  );

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WaitingOrderModal)
);
